import { AlertV2 } from '@cimplico/components';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { MapAccountResponse } from '../../queries/use-map-workpaper-accounts';
import plural from '../../utilities/plural';
import { MappingFormData } from './AccountsMappingForm';

type AccountsMapResultProps = {
    status: 'success' | 'error';
    results: MapAccountResponse | { message: string };
};

function AccountsMapResult({ status, results }: AccountsMapResultProps): JSX.Element {
    const form = useFormContext<MappingFormData>();

    const { fields } = useFieldArray({ control: form.control, name: 'mappings' });

    const errors = Array.isArray(results)
        ? results
              .filter((r) => r.outcome === 'failed')
              .map((r) => {
                  const matchingAccount = fields.find((f) => f.account.id === r.original.accountId);
                  if (!matchingAccount) {
                      return '';
                  }
                  const label = matchingAccount.account.code
                      ? `${matchingAccount.account.code} - ${matchingAccount.account.description}`
                      : matchingAccount.account.description;
                  // @ts-ignore
                  return `${label}: ${r.reason}`;
              })
        : results.message;

    if (status === 'success' && Array.isArray(results)) {
        return (
            <AlertV2
                type="success"
                title="Successfully mapped accounts"
                description={`You successfully mapped ${results.length} ${plural(
                    results.length,
                    'account'
                )} in this workpaper to the entity's chart`}
            />
        );
    }
    return (
        <AlertV2
            type="error"
            title=" Please address the below issues and try again."
            // @ts-ignore
            description={errors}
        />
    );
}

export default AccountsMapResult;
